import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
    display: "flex",
    gap: "10px",
  },
  sectorSelect: {
    width: "100px",
  },
  suffixInput: {
    width: "60px",
  },
});

export const AddArtificialPostcodeContent = ({
  sectors,
  selectedSector,
  onSectorChange,
  postcodeSuffix,
  onPostcodeSuffixChange,
  sectorError,
  suffixError,
}) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <FormControl
        className={styles.sectorSelect}
        variant={"outlined"}
        error={!!sectorError}
      >
        <InputLabel id="new-postcode-sector">Sector</InputLabel>
        <Select
          label={"Sector"}
          labelId="new-postcode-sector"
          name={"sector"}
          onChange={onSectorChange}
          value={selectedSector}
        >
          {sectors.sort().map((sector, index) => (
            <MenuItem key={index} value={sector}>
              {sector}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText error={true}>{sectorError}</FormHelperText>
      </FormControl>

      <TextField
        className={styles.suffixInput}
        value={postcodeSuffix}
        onChange={onPostcodeSuffixChange}
        variant={"outlined"}
        label={"Suffix"}
        name={"selectTime"}
        error={!!suffixError}
        FormHelperTextProps={{
          style: { marginLeft: "0px" },
        }}
        helperText={suffixError}
      />
    </View>
  );
};
